import { get, isEmpty } from 'lodash'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import { SUBCATEGORIES } from 'constants/layout/setup-activity'

export default function(fields = {}, { eventCategory, pEId, award }) {
  const transportationModes = get(fields, 'transportationModes') || []

  const transportationModeList = transportationModes && transportationModes.map(item => {
    return {
      ajEventTemplate: { id : get(fields, 'id') },
      transportationMode: {
        id: get(item, 'id')
      }
    }
  })

  const schema = {
    id: pEId || undefined,
    aim: get(fields, 'aim'),
    title: get(fields, 'title'),
    setupAssessorId: get(fields, 'assessorId'),
    setupSupervisorId: get(fields, 'supervisorId'),
    ajEvent: {
      ...fields,
      activityCategory: isEmpty(fields.activityCategory)
        ? null
        : fields.activityCategory,
      location: `${get(fields, 'helpers.location')}`,
      ajEventCategory: {
        value: eventCategory
      },
      awardLevel: {
        value: get(award, 'awardLevel.value')
      },
      organization: {
        id: get(award, 'organization.id')
      },
      helpers: undefined,
      transportationModes: transportationModeList
    },
    award: {
      id: get(award, 'id')
    }
  }

  if (get(fields, 'activityCategory.id') === SUBCATEGORIES.others.value) {
    schema.ajEvent.activityCategory = {
      activitySection: {
        value: ACTIVITY_SECTIONS.adventurous_journey.id
      },
      parent: {
        id: get(fields, 'helpers.category')
      },
      userDefined: true,
      name: get(fields, 'helpers.others')
    }
  }

  return schema
}
